








import { Component, Prop, Vue, Model } from 'vue-property-decorator'
import { ReservedBy } from '@/types/reservation'

@Component
export default class ReservatioonMethoodSelect extends Vue {
  @Model('change', { default: null }) readonly value!: ReservedBy
  @Prop({ default: () => '' }) readonly label!: string
  get items() {
    return [
      { text: this.$t('reservation.methodSelect.text.directVisit'), value: ReservedBy.Direct },
      { text: this.$t('reservation.methodSelect.text.nextReservation'), value: ReservedBy.Repeat },
      { text: this.$t('reservation.methodSelect.text.phoneReservation'), value: ReservedBy.Phone },
      { text: this.$t('reservation.methodSelect.text.hotpepper'), value: ReservedBy.Hotpepper },
      // { text: 'コールセンター', value: ReservedBy.CallCenter },
      { text: this.$t('reservation.methodSelect.text.line'), value: ReservedBy.Line },
      { text: this.$t('reservation.methodSelect.text.preOpen'), value: ReservedBy.PreOpen },
      { text: this.$t('reservation.methodSelect.text.nextReservationCustomer'), value: ReservedBy.ShopTablet },
      { text: this.$t('reservation.methodSelect.text.inShopTerminal'), value: ReservedBy.InShop2 },
      { text: this.$t('reservation.methodSelect.text.beautyMerit'), value: ReservedBy.BeautyMerit },
      { text: this.$t('reservation.methodSelect.text.reservationApp'), value: ReservedBy.App },
      { text: this.$t('reservation.methodSelect.text.googleMap'), value: ReservedBy.Google },
      { text: this.$t('reservation.methodSelect.text.other'), value: ReservedBy.Other },
    ]
  }
}
